"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLensCursorOffset = void 0;
const imageRatio_1 = require("./imageRatio");
function getLensCursorOffsetDimension(value, ratio) {
    return Math.round((value * ratio) / 2);
}
function getLensCursorOffset(smallImage, largeImage, enlargedImageContainerDimensions) {
    const ratio = (0, imageRatio_1.getLargeToSmallImageRatio)(smallImage, largeImage);
    return {
        x: getLensCursorOffsetDimension(enlargedImageContainerDimensions.width, ratio.x),
        y: getLensCursorOffsetDimension(enlargedImageContainerDimensions.height, ratio.y),
    };
}
exports.getLensCursorOffset = getLensCursorOffset;
//# sourceMappingURL=lens.js.map